export default __webpack_public_path__ + "static/media/none.3e1fffaf.svg";